module.exports = __webpack_public_path__ + "f92e1966b4c1fc7b356816a19654b3de.svg";